var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading && !_vm.error)?_vm._t("default"):_c('div',{staticClass:"centerer"},[(_vm.loading)?_c('a-spinner',{attrs:{"big":""}}):_vm._t("error")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }